// extracted by mini-css-extract-plugin
export var filename = "_1279dfa137704567901fec49e7edaa3b-css";
export var progressText = "efdb61fccf8dcc1c9cf2fd65cdaaa9a1-css";
export var progressTextSize = "_351dc75564392b1a217f2ae521630030-css";